module.exports = __webpack_public_path__ + "img/utility-pole.1785c40c.svg";